import React from 'react';

import { useTranslation } from 'react-i18next';
import {Card, Message} from '@weezevent/nacre';
import EventCreationContact from '../../event_creation/eventCreationContact';


export default function ContactForm({id='event-form-contact', ...props}){
    const { t } = useTranslation();

    return (
        <Card.FormStep
            title={t('ticket.event.edit.contactTitle')}
            subtitle={t('ticket.event.edit.contactSubtitle')}
            id={id}
            rightComponent={
                <Message type="tips" title={t('ticket.common.tips')} mini>
                    {t('ticket.event.edit.contactTips')}
                </Message>
            }
        >
            <EventCreationContact {...props} />
        </Card.FormStep>
    );
}
